export default __webpack_public_path__ + "images/assets/3727da283de685c90be0719e7353e72a.svg";